import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class ContactFormSupport extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get osVersion() {
    return get(this, '_os_version.value', '');
  }

  get company() {
    return get(this, '_company.value', '');
  }

  get email() {
    return get(this, '_email.value', '');
  }

  get emailLabel() {
    return get(this, '_email_label.value', '');
  }

  get submitButtonText() {
    return get(this, '_submit_button_text.value', '');
  }

  get messageLabel() {
    return get(this, '_message_label.value', '');
  }

  get firstNameLabel() {
    return get(this, '_first_name_label.value', '');
  }

  get lastNameLabel() {
    return get(this, '_last_name_label.value', '');
  }

  get phoneLabel() {
    return get(this, '_phone_label.value', '');
  }

  get clientSystem() {
    return get(this, '_client_system.value', '');
  }
  
  get reCaptchaErrorMessage() {
    return get(this, '_recaptcha_error_message.value', '');
  }

  get htmlModifiers() {
    return get(this, '_html_modifiers', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/ContactFormSupport.model.js